import styles from "./DetailsRow.module.scss";

type DetailsRowProps = {
  icon: React.ReactNode;
} & React.PropsWithChildren;

export const DetailsRow = ({ icon, children }: DetailsRowProps) => {
  return (
    <div className={styles.detailsRow}>
      <div className={styles.iconContainer}>{icon}</div>
      {children}
    </div>
  );
};
